<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            دریافت خروجی اکسل کاربران 
        </a-button>

        <a-modal width="1000px" v-model="visible" title="    دریافت خروجی اکسل کاربران   " on-ok="handleOk">
            <div class="row">
                <div class="col-md-6 offset-6 ">
                    <div class="form-group">
                        <label style="margin-bottom:10px;">در تاریخ </label>
                        <date-picker v-model="info.start"></date-picker>

                    </div>
                </div>


            </div>
            <template slot="footer">
                <a-button target="_blank" @click.prevent="validate()" :href="`${$store.state.baseUrl}/user-export?start=${info.start}`">
                                        <a-icon type="upload" />  خروجی اکسل  
                                    </a-button>
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>
            </template>



        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            answers: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                info: {}
            };
        },
        methods: {
            validate(){
                if(this.info.start == undefined){
                    this.$toast.error("لطفا بازه زمانی را وارد کنید.");
                }else{
                location.href=`${this.$store.state.baseUrl}/user-export?start=${this.info.start}`

                }

            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')

            },

        },
    };
</script>
